// eslint-disable-next-line import/order
import "./polyfills";

import { createRoot } from "react-dom/client";

import "@fontsource-variable/inter";

import { App } from "./app";
import SchoolSDK from "./shared/lib/school-sdk";
import { registerStaticAntTheme } from "./shared/lib/theme/staticAntTheme";
import { applyDocumentTheme, readThemeMode, resolveTheme } from "./shared/lib/theme/theme";

window.AXLSchool = new SchoolSDK();

// Before the first render and the first toast: the marker every theme consumer reads, and the static-API holder.
applyDocumentTheme(resolveTheme(readThemeMode()));
registerStaticAntTheme();

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
